import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./Navigation/navbar";
import Login from "./Pages/Login/Login";
import SignUp from "./Pages/Login/SignUp";
import ForgotPassword from "./Pages/Login/forgotpassword";
import ResetPassword from "./Pages/Login/ResetPassword";
import { LoadingProvider } from "./Context/LoadingContext";
import { UserProvider } from "./Context/userContext";
import { RoleProvider } from "./Context/roleContext";
import { PERMISSIONS } from "./Constants/permissions";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import Dashboard from "./Pages/Dashboard/Dashboard";
import UserForm from "./Pages/User/Userform";
import Users from "./Pages/User/User";
import RoleUser from "./Pages/UserRoles/UserRole";
import RoleUserAddForm from "./Pages/UserRoles/AddRoleForm";
import RoleUserEditForm from "./Pages/UserRoles/EditRoleForm";
import DocumentsDetails from "./Pages/Documents/DocumentDetails";
import DocumentsList from "./Pages/Documents/DocumentsList";
import Profile from "./Navigation/Profile";
// import Settings from "./Navigation/Settings";
// import Reference from "./Pages/Reference/Refer";
// import Referenceform from "./Pages/Reference/Referform";
import { ReferenceProvider } from "./Context/ReferContext";
import Project from "./Pages/ProjectType/ProjectList";
import ProjectCreation from "./Pages/ProjectType/Project";
import Restricted from "./Pages/Unauth/Restricted";
import AddDocument from "./Pages/Documents/AddDocument";
import Department from "./Pages/Department/department";
import AccessDocument from "./Pages/Documents/AccessDocument";
import HeaderNav from "./Navigation/headernav";
import { ExternalUserProvider } from "./Context/ExternalUserContext";
import InternalUser from "./Pages/Login/internalUserAccess";
import ExternalFinalPage from "./Pages/Documents/ExternalFinalPage";
import PublicRoute from "./Components/ProtectedRoute/PublicRoute";
import NotFound from "./Pages/Unauth/NotFound";
const App = () => {
  return (
    <LoadingProvider>
      <UserProvider>
        <RoleProvider>
          <ReferenceProvider>
            <ExternalUserProvider>
              <AppWithNavigation />
            </ExternalUserProvider>
          </ReferenceProvider>
        </RoleProvider>
      </UserProvider>
    </LoadingProvider>
  );
};

const AppWithNavigation = () => {
  const location = useLocation();
  const [isNavbarOpen, setIsNavbarOpen] = useState(true);
  const showNav = /^\/public-access\/[^/]+\/[^/]+$/.test(location.pathname);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsNavbarOpen(false);
      } else {
        setIsNavbarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showNavigation =
    location.pathname !== "/" &&
    location.pathname !== "/forgot-password" &&
    location.pathname !== "/reset-password" &&
    location.pathname !== "/thank-you" &&
    location.pathname !== "/signup" &&
    !location.pathname.startsWith("/public-access/") &&
    !location.pathname.startsWith("/secure-access/");

  return (
    <div className="App flex flex-col min-h-screen">
      {showNav && <HeaderNav />}
      {showNavigation && (
          <ProtectedRoute>
        <Navigation
          isNavbarOpen={isNavbarOpen}
          toggleNavbar={() => setIsNavbarOpen(!isNavbarOpen)}
        />
        </ProtectedRoute>
      )}

      <main
        className={`flex-grow bg-gray-100 transition-all duration-300 ${
          showNavigation ? (isNavbarOpen ? "ml-60" : "ml-16") : ""
        }`}
      >
        <Routes>
          <Route
            path="/"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route path="/signup" element={<SignUp/>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/public-access/:externalUserid/:documentId"
            element={<AccessDocument />}
          />
          <Route path="/thank-you" element={<ExternalFinalPage />} />

          <Route
            path="/secure-access/:userId/:documentId"
            element={<InternalUser />}
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/department"
            element={
              <ProtectedRoute>
                <Department />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute
                requiredPermission={
                  PERMISSIONS.VIEW_USERS ||
                  PERMISSIONS.EDIT_USER ||
                  PERMISSIONS.DELETE_USER
                }
              >
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/userform/:userId"
            element={
              <ProtectedRoute
                requiredPermission={ 
                  PERMISSIONS.EDIT_USER 
                }
              >
                <UserForm />
              </ProtectedRoute>
            }
          />
            <Route
            path="/userform/new"
            element={
              <ProtectedRoute
                requiredPermission={
                  PERMISSIONS.ADD_USER
                }
              >
                <UserForm />
              </ProtectedRoute>
            }
          />
          
      
          <Route
            path="/RoleUser"
            element={
              <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_ROLE}>
                <RoleUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/RoleUserAddform"
            element={
              <ProtectedRoute requiredPermission={PERMISSIONS.ADD_ROLE}>
                <RoleUserAddForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/RoleUserEditform/:roleId"
            element={
              <ProtectedRoute requiredPermission={PERMISSIONS.EDIT_ROLE}>
                <RoleUserEditForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documentsDetails/:documentId/:userId?"
            element={
              <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_DOCUMENT}>
                <DocumentsDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documentsList"
            element={
              <ProtectedRoute>
                <DocumentsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/Settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          /> */}
          {/* <Route
            path="/Reference"
            element={
              <ProtectedRoute requiredPermission={PERMISSIONS.VEIW_REFERENCES}>
                <Reference />
              </ProtectedRoute>
            }
          /> */}
          {/* <Route
            path="/Referenceform/:ReferId"
            element={
              <ProtectedRoute
                requiredPermission={
                  PERMISSIONS.ADD_REFERENCES ||
                  PERMISSIONS.EDIT_REFERENCES ||
                  PERMISSIONS.DELETE_REFERENCES
                }
              >
                <Referenceform />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/ProjectCreation"
            element={
              <ProtectedRoute requiredPermission={PERMISSIONS.ADD_PROJECT_TYPE}>
                <ProjectCreation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Project"
            element={
              <ProtectedRoute
                requiredPermission={
                  PERMISSIONS.VIEW_PROJECT_TYPE ||
                  PERMISSIONS.DELETE_PROJECT_TYPE
                }
              >
                <Project />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ProjectCreation/:ProjectTypeID"
            element={
              <ProtectedRoute
                requiredPermission={
                  PERMISSIONS.EDIT_PROJECT_TYPE || PERMISSIONS.ADD_PROJECT_TYPE
                }
              >
                <ProjectCreation />
              </ProtectedRoute>
            }
          />
          <Route path="/add-document/:documentId"
           element={
             <ProtectedRoute
                requiredPermission={
                  PERMISSIONS.EDIT_DOCUMENT
                }
              >
                <AddDocument />
               </ProtectedRoute>
          }/>
             <Route path="/add-document/new"
           element={
             <ProtectedRoute
                requiredPermission={
                  PERMISSIONS.ADD_DOCUMENT
                }
              >
                <AddDocument />
               </ProtectedRoute>
          }/>
            
          <Route path="/unauthorized" element={<Restricted />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;
